import React from 'react';

import './closedBanner.scss';

/**
 * The ClosedBanner component.
 *
 * @constructor
 */
export class ClosedBanner extends React.Component {
  /**
   * @constructor
   * @param {{}} props
   * @param {{}} componentContext
   */
  constructor(props, componentContext) {
    super(props, componentContext);
  }

  /**
   * Renders the component.
   *
   * @returns {{}}
   */
  render() {
    return (
      <div className="closed-banner callout alert">
        <h2>This link has expired.</h2>
      </div>
    );
  }
}

ClosedBanner.propTypes = {};

export default ClosedBanner;



// WEBPACK FOOTER //
// ./src/components/common/closedBanner/ClosedBanner.js